<template>
  <div class="w-100 flex flex-column items-center background-color">
    <div class="w-50-ns w-90">
      <form @submit.prevent="forgotPassword(email)">
        <div class="flex flex-column items-center">
          <input class="w-100 block pl1 pr1 pt2 pb2 input" :class="{error: $v.email.$error}"
                  v-model="email" type="text" :placeholder="$t('users.email')" @blur="$v.email.$touch"/>
          <span class="errorText ma1 f7" v-if="$v.email.$error && !$v.email.required">{{ $t('error.emailRequired') }}</span>
          <span class="errorText ma1 f7" v-if="$v.email.$error && !$v.email.email">{{ $t('error.emailInvalid') }}</span>
          <input class="w-100 block mv2 pointer btn dim b f5 fw4 bg-black text-color" type="submit" :value="$t('users.forgetPassword.button')">
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { required, email } from 'vuelidate/lib/validators'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'forgot-pass',
    data () {
      return {
        email: ''
      }
    },
    computed: {
      ...mapGetters('user', [
        'isLoggedIn',
        'isEmailSent',
        'error'
      ])
    },
    methods: {
      ...mapActions('user', [
        'forgotPass'
      ]),
      forgotPassword (email) {
        if (!this.$v.email.$invalid) {
          if (!this.isLoggedIn) {
            this.forgotPass(email).then(() => {
              if (this.isEmailSent) {
                this.$toasted.show(this.$t('user.forgetPassword.success'), {
                  type: 'success'
                })
                this.$modal.hide('login-modal')
              }
            }).catch((e) => {
            })
          }
        } else {
          this.$v.$touch()
        }
      }
    },
    validations: {
      email: {
        email,
        required
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '~@/variables.scss';

  .background-color{
    background-color: #393839;
  }
  .text-color{
    color: #aaa;
  }

</style>



// WEBPACK FOOTER //
// src/components/modals/login/ForgotPass.vue